/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceType {
    Standard = 'STANDARD'
}

export function DeviceTypeFromJSON(json: any): DeviceType {
    return DeviceTypeFromJSONTyped(json, false);
}

export function DeviceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceType {
    return json as DeviceType;
}

export function DeviceTypeToJSON(value?: DeviceType | null): any {
    return value as any;
}

